export default __webpack_public_path__ + "static/media/ka.66465ef6.jpg";